// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","dotNav":"_3DIJ1M","active":"DeYwdv","fadeInFrames":"LKUSj7"};